import { render, staticRenderFns } from "./IncidentLocation.vue?vue&type=template&id=3884f9af&scoped=true&"
import script from "./IncidentLocation.vue?vue&type=script&lang=js&"
export * from "./IncidentLocation.vue?vue&type=script&lang=js&"
import style0 from "./IncidentLocation.vue?vue&type=style&index=0&id=3884f9af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3884f9af",
  null
  
)

export default component.exports